import {
  Box,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { AccountCircleOutlined } from '@mui/icons-material';
import { House } from 'lucide-react';
import { CARD_SX, SECTION_ICON_BOX_SX } from './accountOverview.utils';

export default function AccountOverviewHero({ navigate }) {
  return (
    <>
      <Tooltip title="Voltar para produtos">
        <IconButton
          onClick={() => navigate('/products')}
          aria-label="Voltar para produtos"
          sx={{
            alignSelf: 'flex-start',
            width: 44,
            height: 44,
            color: '#475569',
            border: '1px solid rgba(148, 163, 184, 0.4)',
            backgroundColor: '#fff',
            transition: 'all .2s ease',
            '&:hover': {
              background: '#0891b2',
              color: '#fff',
              borderColor: '#0891b2',
            },
          }}
        >
          <House size={22} strokeWidth={2.2} />
        </IconButton>
      </Tooltip>

      <Box sx={{ ...CARD_SX, position: 'relative' }}>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            background:
              'linear-gradient(90deg, #06b6d4 0%, #8b5cf6 50%, #f59e0b 100%)',
          }}
        />
        <Box sx={{ p: { xs: 2.5, md: 3 }, pt: { xs: 3, md: 3.5 } }}>
          <Stack direction="row" alignItems="center" gap={2}>
            <Box
              sx={{
                ...SECTION_ICON_BOX_SX,
                width: 52,
                height: 52,
                borderRadius: '16px',
              }}
            >
              <AccountCircleOutlined sx={{ fontSize: 28 }} />
            </Box>
            <Box>
              <Typography
                component="h1"
                variant="h5"
                sx={{
                  fontWeight: 700,
                  letterSpacing: '-0.02em',
                  color: '#0f172a',
                  mb: 0.25,
                }}
              >
                Minha conta
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b', maxWidth: 720 }}>
                Acompanhe status da assinatura, plano contratado, produtos disponíveis e histórico de pagamentos.
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Box>
    </>
  );
}
